import { render } from "./Google.vue?vue&type=template&id=2f1311e0&scoped=true"
import script from "./Google.vue?vue&type=script&lang=js"
export * from "./Google.vue?vue&type=script&lang=js"

import "./Google.vue?vue&type=style&index=0&id=2f1311e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1311e0"]])

export default __exports__